// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import Loader from '../../components/Utils/Loader';
import SmartDevicesList from '../../components/Dashboard/SmartDevicesList';

var dashboardCommonJS = require("../../js/dashboardCommon.js");

// Función del router
const DevicesOperationMenu = (params) => {

    useEffect(() => {           
        console.log("Menu de operación de dispositivos cargado correctamente.") 
    }, [params.objListadoDispositivos]);

    function gestionarVisibilidadMenuDispositivos(event) {        
      if ( !document.getElementById("menuDispositivos").className.includes("hidden") && (event.target.id === "menuDispositivos") ){
        dashboardCommonJS.operarMenuDispositivos("cerrar", "")
      }
    };

  return (    

    <React.Fragment key="Menu">
    <aside id="menuDispositivos" className="modal lateral-detail hidden" onMouseDown={gestionarVisibilidadMenuDispositivos}>
      <div className="modal-content">
        <button className="link close" onClick={() => dashboardCommonJS.operarMenuDispositivos("cerrar", "")}><span className="material-icon">highlight_off</span></button>
        <div className="page"> 
          <header className="horizontal center gap-04">
            <figure className="avatar size-xl cyan"><span className="material-icon">devices_other</span></figure>
            <dl className="vertical fill"><dd id="numeroDispositivosDetalle" className="headline-02"></dd></dl>
          </header>

          { dashboardCommonJS.comprobarPropiedadInstalacion() === true ?
            <button className="selector icon-wrapper no-icon" onClick={() => dashboardCommonJS.añadirDispositivo("MenuDispositivosDashboard")}>
              <figure className="avatar size-m blue">
                <span className="material-icon">add</span>
              </figure>
              <div className="content">
                <h1>Añadir dispositivo</h1>
              </div>
            </button>  
            :            
            <></>
          }

          <div id="detalleDISPOSITIVOS_INTELIGENTES" className="accordion-wrapper">          
            <SmartDevicesList objListadoDispositivos={params.objListadoDispositivos} update={params.devicesUpdateTimestamp}/>
          </div>

          <Loader Id="loaderMenuDispositivos" Mensaje=""/>

        </div>
      </div>

    </aside>
    </React.Fragment>

  )
}

export default DevicesOperationMenu